
function navbarScrollhide() {

	// Hide Header on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('.navbar').outerHeight();

	function hasScrolled() {
		var st = $(this).scrollTop();

		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta) {
			return;
		}

		// Scrolled past navbar
		if ( st > navbarHeight ) {
			// Scroll Down
			if ( st > lastScrollTop ){
				$('body').removeClass('scroll-up').addClass('scroll-down');
			// Scroll Up
			} else {
				if ( st + $(window).height() < $(document).height() ) {
					$('body').removeClass('scroll-down').addClass('scroll-up');
				}
			}
		// Not scrolled past navbar yet
		} else {
			$('body').removeClass('scroll-up scroll-down');
		}

		lastScrollTop = st;
	}

	$(window).scroll(function(event){
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

}
